import { Link, useNavigate, useSearchParams } from "react-router-dom"
import { Footer } from "../../Footer/Footer"
import { HerosectionsAll } from "../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../IndexPage/Header/Header"


export const LearningAndDevelopment = ({ actives }) => {
    const [searchParams] = useSearchParams()
    let Section = searchParams.get("Section")

    const navigate = useNavigate()
    return (
        <>
            <div className="container-fluid">
                <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                    <div className="col-12">
                        <Header actives="LearningAndDevelopment" subactive="Services" />

                        <HerosectionsAll
                            // ScreenName="Learning And Development"
                            ScreenName={Section}
                            ScreenSearch="LearningAndDevelopment"
                        />

                        <div className="row p-2 p-lg-5  mx-auto mb-5 pt-5">

                            {
                                (Section == "Contents on Board" || Section == "Learning And Development") &&

                                <div className="col-12 col-lg-5 mx-auto p-2 p-lg-4 pb-lg-5">
                                    <div className=" consutancy_three2 p-lg-3">
                                        <div className="row cursor_pointer pt-5 Professional_img">
                                            <h5 className="text-white text-center  mb-0 pt-5 Professional ">
                                                Contents on Board</h5>
                                            <ul className="ps-lg-5">
                                                <li className="pb-2 ms-5 ms-lg-4"
                                                    onClick={() => navigate('/Services?ScreenName=Principles of Insurance&Name=Services&SubName=Learning And Development')}
                                                >Principles of Insurance </li>
                                                <li className="py-2 ms-5 ms-lg-4"
                                                    onClick={() => navigate('/CargoInsurance?ScreenName=Cargo Insurance&Name=Services&SubName=Learning And Development')}
                                                >  Cargo Insurance </li>
                                                <li className="py-2 ms-5 ms-lg-4"
                                                    onClick={() => navigate('/HullInsurance?ScreenName=Hull Insurance&Name=Services&SubName=Learning And Development')}
                                                > Hull Insurance </li>
                                                <li className="py-2 ms-5 ms-lg-4"
                                                    onClick={() => navigate('/MarineLiabilityInsurance?ScreenName=Marine Liability Insurance&Name=Services&SubName=Learning And Development')}
                                                > Marine Liability Insurance </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            }

                            {
                                (Section == "Professional Development" || Section == "Learning And Development") &&

                                <div className="col-12 col-lg-5 mx-auto p-2 p-lg-4 pb-lg-5">
                                    <div className=" consutancy_three2  p-lg-3">
                                        <div className="row cursor_pointer pt-5 Professional_img">
                                            <h5 className="text-white text-center  pt-5 Professional ">Professional Development</h5>

                                            <ul className="ps-lg-5">
                                                <li className="py-2 ms-5 ms-lg-4"
                                                    onClick={() => navigate('/TrainingOnlineOffline?ScreenName=Training Online / Offline&Name=Services&SubName=Learning And Development')}
                                                > Training Online / Offline </li>
                                                <li className="py-2 ms-5 ms-lg-4"
                                                    onClick={() => navigate('/WorkshopOnlineOffline?ScreenName=Workshop Online Offline&Name=Services&SubName=Learning And Development')}
                                                > Training Methodology </li>
                                                <li className="py-2 ms-5 ms-lg-4"
                                                    onClick={() => navigate('/Seminars?ScreenName=Seminars&Name=Services&SubName=Learning And Development')}
                                                > Seminars </li>
                                                <li className="py-2 ms-5 ms-lg-4"
                                                    onClick={() => navigate('/Lectures?ScreenName=Lectures&Name=Services&SubName=Learning And Development')}
                                                > Lectures </li>
                                                <li className="py-2 ms-5 ms-lg-4"
                                                    onClick={() => navigate('/IndividualCorporateTrainings?ScreenName=IndividualCorporateTrainings&Name=Services&SubName=Learning And Development')}
                                                >  Individual / Corporate Trainings </li>

                                                <li className="py-2 ms-5 ms-lg-4"
                                                    onClick={() => navigate('/ExaminationStructure')}
                                                >   Insurance Institute of India Examinations</li>

                                            </ul>

                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>

        </>
    )
}
